import { FC } from "react";
import classNames from "classnames";
import CloseIcon from "assets/icons/loyalty/cross-white.svg?react";
import TimerProgress from "components/atoms/TimerProgress";
import { LoyaltyOnboardingPopupProps } from "./types";
import "./styles.sass";

const LoyaltyOnboardingPopup: FC<LoyaltyOnboardingPopupProps> = ({
  durations,
  isActive,
  isHide,
  handleNext,
  handleClickClose,
  handleClick,
  children,
}) => {
  const classNameComponent = classNames(
    "LoyaltyOnboardingPopup",
    isActive && "LoyaltyOnboardingPopup_active",
    isHide && "LoyaltyOnboardingPopup_hide",
  );

  const classNamesDurations = classNames(
    "LoyaltyOnboardingPopup__durations",
    isActive && "LoyaltyOnboardingPopup__durations_active",
  );

  return (
    <div
      className={classNameComponent}
      onClick={(event) => {
        event.stopPropagation();
        handleClick?.();
      }}
    >
      <div className="LoyaltyOnboardingPopup__content">
        <div className="LoyaltyOnboardingPopup__header">
          {isActive && (
            <CloseIcon
              className="LoyaltyOnboardingPopup__icon"
              width="20px"
              height="20px"
              onClick={handleClickClose}
            />
          )}
        </div>
        <div
          className={classNamesDurations}
          style={{
            gridTemplateColumns: durations
              ? `repeat(${durations.length}, 1fr)`
              : "auto",
          }}
        >
          {isActive &&
            durations?.map((duration) => (
              <TimerProgress
                key={duration.key}
                duration={duration.duration}
                isFinished={duration.isFinished}
                isProgress={duration.isProgress}
                onFinish={handleNext}
              />
            ))}
        </div>
        {children}
      </div>
    </div>
  );
};

export default LoyaltyOnboardingPopup;
